import axios from "axios";
import APICall from "../APICall";
import { Base_URL } from "../utils/constant";

const login = async (payload) => {
  const response = await APICall("account/login", "POST", payload);
  return response;
};

const googleAuth = async (payload) => {
  const response = await APICall("account/auth/google", "POST", payload);
  return response;
};

const verifyEmailV2 = async (payload) => {
  const response = await APICall("account/verify-email-v2", "POST", payload);
  return response;
};

const loginWithPin = async (payload) => {
  const response = await APICall("account/login-pin", "POST", payload);
  return response;
};

const register = async (payload) => {
  const response = await APICall("account/register", "POST", payload);
  return response;
};

const verifyOTP = async (payload) => {
  const response = await APICall("account/verify-otp", "POST", payload);
  return response;
};

const resendOTPCode = async (payload) => {
  const response = await APICall("account/resend-otp", "POST", payload);
  return response;
};

const setTransactionPin = async (payload) => {
  const response = await APICall("account/set-pin", "POST", payload);
  return response;
};

const verifyPhoneNumber = async (payload) => {
  const response = await APICall("account/verifyphone", "POST", payload);
  return response;
};

const resendVerifyPhoneNumber = (payload) => {
  const response = APICall(
    "account/resend-verification-phone",
    "POST",
    payload
  );
  return response;
};

const resendOTP = (payload) => {
  const response = APICall("account/resend-verification", "POST", payload);
  return response;
};

const resetPassword = (payload) => {
  const response = APICall("account/change_password", "POST", payload);
  return response;
};

const verifyNewDeviceLogin = (payload) => {
  const response = APICall("account/validate-device", "POST", payload);
  return response;
};

// Returns { ok, message } so the caller can always show the backend's reason
// (e.g. PHONE_ALREADY_EXISTS) instead of relying on APICall's generic toast.
const updatePhone = async (payload) => {
  const base = Base_URL.endsWith("/") ? Base_URL : `${Base_URL}/`;
  try {
    const res = await axios.post(`${base}account/update-phone`, payload, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    if (res?.status >= 200 && res?.status < 300 && res.data?.status !== false) {
      return { ok: true, message: res.data?.message };
    }
    return {
      ok: false,
      message:
        res?.data?.message || "Unable to update phone number. Please try again.",
    };
  } catch (error) {
    return {
      ok: false,
      message:
        error?.response?.data?.message ||
        "Please check your network connection and try again",
    };
  }
};

const onboardUser = async (payload) => {
  const response = await APICall("account/onboard-user", "POST", payload);
  return response;
};

const updateNotificationToken = (payload) => {
  const response = APICall("user/notification-token", "PUT", payload);
  return response;
};

const authService = {
  login,
  googleAuth,
  resendOTP,
  resetPassword,
  register,
  verifyPhoneNumber,
  resendVerifyPhoneNumber,
  verifyOTP,
  resendOTPCode,
  setTransactionPin,
  verifyNewDeviceLogin,
  loginWithPin,
  verifyEmailV2,
  updatePhone,
  onboardUser,
  updateNotificationToken,
};

export default authService;
